import { StreamMessage } from 'stream-chat-react';

import PushPinIcon from '@mui/icons-material/PushPin';

import { StreamChatType } from '../types';

export type PinIndicatorProps = {
  message?: StreamMessage<StreamChatType>;
};

export const PinIndicator = ({ message }: PinIndicatorProps) => {
  if (!message) return null;

  return (
    <div className='str-chat__message-team-pin-indicator'>
        <PushPinIcon className='pinIcon' />
          {message.pinned_by
            ? `Pinned by ${message.pinned_by?.name || message.pinned_by?.id}`
            : 'Message pinned'}
    </div>
  );
};
